/**
 * src/services/profileService.js
 */
import api from "../lib/api";

const getProfile = async () => {
  const response = await api.get("/auth/me");
  return response.data;
  // Returns: { success, data: { name, email, role, specialization,
  //            employeeId, dateOfJoining, profilePicture } }
};

const changePassword = async ({ currentPassword, newPassword }) => {
  const response = await api.put("/auth/me/password", {
    currentPassword,
    newPassword,
  });
  return response.data;
};

const uploadProfilePicture = async (formData) => {
  const response = await api.put("/auth/me/profile-picture", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
  // Returns: { success, data: { profilePicture: "https://s3-url..." } }
};
const deleteProfilePicture = async () => {
  const response = await api.delete("/auth/me/profile-picture");
  return response.data;
  // Returns: { success, message }
};

const profileService = {
  getProfile,
  changePassword,
  uploadProfilePicture,
    deleteProfilePicture,
};

export default profileService;
